import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";

const StickyMobileCTA = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isQuotePage = location.pathname === "/instant-quote";
  const isPayment = location.pathname.startsWith("/payment");

  if (isAdmin || isQuotePage || isPayment) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden" data-testid="sticky-mobile-cta">
      <div className="bg-[#0F172A] border-t border-slate-700 px-4 py-3 flex gap-3">
        <a
          href="tel:07346209593"
          className="flex-1 flex items-center justify-center gap-2 bg-white text-[#0F172A] font-semibold py-3 text-sm transition-colors active:bg-slate-100"
          data-testid="sticky-call-btn"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <Link
          to="/instant-quote"
          className="flex-[2] flex items-center justify-center gap-2 bg-[#FF5A1F] text-white font-semibold py-3 text-sm transition-colors active:bg-[#e54e18]"
          data-testid="sticky-quote-btn"
        >
          Get Your Free Quote
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
